import { redirect, type LoaderFunctionArgs } from 'react-router-dom';
import { authService } from '@root/app/shared/new-services/auth.service';
import { companyService } from '@root/app/shared/new-services/company.service';
import { getRouteByPath, isPublicPath } from '@root/app/routing/routeManifest';

const normalizePathname = (pathname: string): string => pathname.replace(/\/+$/, '') || '/';

export const protectedRouteLoader = async ({ request }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const pathname = normalizePathname(url.pathname);

    if (!authService.isLoggedIn()) {
        if (isPublicPath(pathname)) {
            return null;
        }
        const redirectParam = encodeURIComponent(pathname);
        return redirect(`/onboarding?redirect=${redirectParam}`);
    }

    const route = getRouteByPath(pathname);
    if (route?.meta.roles && !authService.userHasRole(route.meta.roles)) {
        return redirect('/onboarding?roleDenied=1');
    }
    if (route?.meta.pureAdvisor && !authService.isPureAdvisor()) {
        return redirect('/onboarding?roleDenied=1');
    }

    return new Promise((resolve) => {
        companyService.getUserCompany((err, company) => {
            if (err || !company) {
                resolve(null);
                return;
            }

            // setup.initial is not migrated; CREATED companies land on dashboard onboarding flow
            if (!authService.isADVISOR() && company.launchStatus === 'CREATED' && !pathname.startsWith('/setup')) {
                resolve(redirect('/private'));
                return;
            }

            if (company.launchStatus !== 'CREATED' && pathname.startsWith('/setup')) {
                resolve(redirect('/private'));
                return;
            }

            resolve(null);
        });
    });
};

export const checkRouteRoles = (roles?: string[]): boolean => {
    if (!roles || roles.length === 0) {
        return true;
    }
    return authService.userHasRole(roles);
};
